import classnames from '../../node_modules/classnames/index.js';
import { useRef, createElement } from 'react';
import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import imageCheckedDisabled from '../images/icons/checkmark-grey.svg';
import imageChecked from '../images/icons/checkmark-white.svg';
import imageCheckedGreen from '../images/icons/checkmark.svg';
import styles from '../styles/Toggle.module.scss';

/**
 * A component that can be used as a checkbox replacement.
 *
 * Note that a disabled style is not currently implemented for all variants,
 * but the control will still be disabled.
 */
var Toggle = function (_a) {
    var _b, _c;
    var checked = _a.checked, className = _a.className, disabled = _a.disabled, name = _a.name, onChange = _a.onChange, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, text = _a.text, _e = _a.type, type = _e === void 0 ? "switch" : _e, rest = __rest(_a, ["checked", "className", "disabled", "name", "onChange", "tabIndex", "text", "type"]);
    var inputRef = useRef(null);
    var handleKeyDown = function (e) {
        var _a;
        if (e.key === " ") {
            e.preventDefault();
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    return (createElement("label", __assign({ className: classnames(styles.label, (_b = {}, _b[styles.disabled] = disabled, _b), className), onKeyDown: handleKeyDown, tabIndex: tabIndex }, rest),
        createElement("input", { checked: checked, className: styles.input, disabled: disabled, name: name, onChange: onChange, 
            // Clicking on anything inside the <label> also sends a
            // click event to the associated input, but only a single
            // click event should bubble.
            onClick: function (e) { return e.stopPropagation(); }, ref: inputRef, type: "checkbox" }),
        createElement("div", { className: classnames(styles[type], (_c = {},
                _c[styles.checked] = checked,
                _c[styles.disabled] = disabled,
                _c)) }, type === "checkbox" && checked ? (createElement("img", { alt: "", className: styles.icon, src: disabled ? imageCheckedDisabled : imageChecked })) : type === "checkbox-green" && checked ? (createElement("img", { alt: "", className: styles.icon, src: imageCheckedGreen })) : null),
        text ? createElement("span", { className: styles.text }, text) : null));
};

export default Toggle;
